export default __webpack_public_path__ + "static/Oil-81b01a9651a74e9d8a621bb4dd67c2bc.png";